<template>
  <div class="mobile-qr-scanner">
    <!-- 摄像头预览区域 -->
    <div
      class="camera-container"
      v-show="isCameraActive"
    >
      <video
        ref="video"
        class="video-preview"
        autoplay
        playsinline
      ></video>
      <div class="scan-guide">
        <div class="guide-frame"></div>
        <div class="guide-text">将二维码放入框内</div>
      </div>
    </div>

    <!-- 控制按钮 -->
    <!-- <div class="controls">
      <button
        class="control-btn"
        @click="toggleCamera"
        :disabled="loading"
      >
        {{ isCameraActive ? '关闭摄像头' : '打开摄像头' }}
      </button>
    </div> -->

    <!-- 状态信息 -->
    <div
      class="status"
      v-if="loading"
    >
      正在初始化摄像头...
    </div>

    <div
      class="status error"
      v-if="error"
    >
      {{ error }}
      <button
        class="retry-btn"
        @click="startCamera"
      >重试</button>
    </div>

    <!-- 扫描结果 -->
    <!-- <div
      class="result"
      v-if="result"
    >
      <div class="result-label">扫描结果：</div>
      <div class="result-text">{{ result }}</div>
      <button
        class="clear-btn"
        @click="result = ''"
      >清除</button>
    </div> -->

    <!-- 未开启摄像头时的提示 -->
    <div
      class="tip"
      v-if="!isCameraActive && !loading && !error"
    >
      点击"打开摄像头"按钮开始扫描二维码
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileQrScanner',

  data() {
    return {
      isCameraActive: false,  // 摄像头是否开启
      loading: false,         // 加载状态
      error: '',              // 错误信息
      result: '',             // 扫描结果
      stream: null,           // 视频流
      scanTimer: null         // 扫描定时器
    }
  },

  mounted() {
    // 动态加载jsQR库
    this.loadQrLibrary()
  },

  beforeDestroy() {
    this.stopCamera()
  },

  methods: {
    // 加载二维码解析库
    loadQrLibrary() {
      // 如果已经加载过，直接返回
      if (window.jsQR) return

      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js'
      document.head.appendChild(script)
    },

    // 切换摄像头
    toggleCamera(is) {
      if (this.isCameraActive) {
        this.stopCamera()
      } else {
        this.startCamera()
      }
    },

    // 启动摄像头
    async startCamera() {
      this.loading = true
      this.error = ''

      try {
        // 请求摄像头权限
        const constraints = {
          video: {
            facingMode: 'environment',  // 优先使用后置摄像头
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        }

        // 获取视频流
        this.stream = await navigator.mediaDevices.getUserMedia(constraints)

        // 显示视频
        const video = this.$refs.video
        video.srcObject = this.stream

        // 等待视频加载
        await new Promise((resolve) => {
          video.onloadedmetadata = () => {
            video.play()
            resolve()
          }
        })

        this.isCameraActive = true
        this.loading = false

        // 开始扫描
        this.startScanning()

      } catch (err) {
        this.loading = false
        this.handleCameraError(err)
      }
    },

    // 停止摄像头
    stopCamera() {
      this.isCameraActive = false

      // 停止扫描
      if (this.scanTimer) {
        clearInterval(this.scanTimer)
        this.scanTimer = null
      }

      // 停止视频流
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop())
        this.stream = null
      }
    },

    // 处理摄像头错误
    handleCameraError(err) {
      console.error('摄像头错误:', err)

      if (err.name === 'NotAllowedError') {
        this.error = '请允许摄像头访问权限'
      } else if (err.name === 'NotFoundError') {
        this.error = '未找到摄像头'
      } else if (err.name === 'NotSupportedError') {
        this.error = '浏览器不支持摄像头'
      } else {
        this.error = '无法访问摄像头'
      }
    },

    // 开始扫描二维码
    startScanning() {
      const video = this.$refs.video
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')

      this.scanTimer = setInterval(() => {
        if (!this.isCameraActive || !video.videoWidth) return

        // 设置画布尺寸（适当缩小以提高性能）
        canvas.width = video.videoWidth / 2
        canvas.height = video.videoHeight / 2

        // 绘制视频帧
        context.drawImage(video, 0, 0, canvas.width, canvas.height)

        // 获取图像数据
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height)

        // 解析二维码
        this.scanQrCode(imageData)
      }, 500)  // 每500ms扫描一次
    },

    // 解析二维码
    scanQrCode(imageData) {
      if (typeof jsQR === 'undefined') return

      try {
        const qrCode = jsQR(
          imageData.data,
          imageData.width,
          imageData.height,
          {
            inversionAttempts: 'dontInvert'
          }
        )

        if (qrCode) {
          this.result = qrCode.data
          console.log('扫描结果:', qrCode.data)

          // 发送事件给父组件
          this.$emit('scan', qrCode.data)
        }
      } catch (err) {
        console.warn('二维码解析失败:', err)
      }
    }
  }
}
</script>

<style scoped>
.mobile-qr-scanner {
  width: 100%;
  max-width: 100%;
  padding: 0;
  font-size: 14px;
}

/* 摄像头容器 */
.camera-container {
  position: relative;
  width: 100%;
  height: 300px;
  background: #000;
  overflow: hidden;
  margin-bottom: 20px;
}

.video-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 扫描引导框 */
.scan-guide {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  height: 250px;
  pointer-events: none;
}

.guide-frame {
  width: 100%;
  height: 100%;
  border: 2px solid rgba(255, 255, 255, 0.7);
  box-sizing: border-box;
}

.guide-frame::before,
.guide-frame::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: #4caf50;
  border-style: solid;
}

.guide-frame::before {
  top: -2px;
  left: -2px;
  border-width: 3px 0 0 3px;
}

.guide-frame::after {
  top: -2px;
  right: -2px;
  border-width: 3px 3px 0 0;
}

.guide-frame .corner-bottom-left {
  position: absolute;
  bottom: -2px;
  left: -2px;
  width: 20px;
  height: 20px;
  border-bottom: 3px solid #4caf50;
  border-left: 3px solid #4caf50;
}

.guide-frame .corner-bottom-right {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-bottom: 3px solid #4caf50;
  border-right: 3px solid #4caf50;
}

.guide-text {
  position: absolute;
  bottom: -40px;
  left: 0;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

/* 控制按钮 */
.controls {
  text-align: center;
  margin: 20px 0;
}

.control-btn {
  width: 90%;
  max-width: 300px;
  padding: 12px 20px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.control-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

/* 状态信息 */
.status {
  padding: 15px;
  margin: 15px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 8px;
}

.status.error {
  background: #ffebee;
  color: #d32f2f;
}

.retry-btn {
  margin-top: 10px;
  padding: 8px 16px;
  background: #ff5722;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

/* 扫描结果 */
.result {
  margin: 20px 15px;
  padding: 15px;
  background: #e8f5e9;
  border-radius: 8px;
  border-left: 4px solid #4caf50;
}

.result-label {
  font-weight: bold;
  margin-bottom: 8px;
  color: #2e7d32;
}

.result-text {
  padding: 10px;
  background: white;
  border-radius: 4px;
  margin-bottom: 10px;
  word-break: break-all;
  font-size: 13px;
  line-height: 1.4;
}

.clear-btn {
  padding: 6px 12px;
  background: #ff9800;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

/* 提示信息 */
.tip {
  padding: 20px;
  text-align: center;
  color: #666;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 20px 15px;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .camera-container {
    height: 300px;
  }

  .scan-guide {
    width: 200px;
    height: 200px;
  }

  .control-btn {
    width: 95%;
    padding: 14px 20px;
  }
}
</style>